function Browse() {
    return (
<section className="flex bg-gray-100 py-16 px-4" id="browse-the-room">
      <div className="container mx-auto">
        <div className="flex flex-start mb-4">
          <h5 className="text-2xl capitalize font-semibold">
          Kami persembahkan<br className="" />Literasi perawatan dan model Rambut kekinian
          </h5>
        </div>
        <div className="grid grid-rows-2 grid-cols-9 gap-4">
          <div
            className="relative col-span-9 row-span-1 md:col-span-4 card"
            style={{height: '180px'}}
          >
            <div className="card-shadow rounded-xl">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/smooting.jpg?alt=media&token=fca503de-ed2e-4b14-89b5-34350e01d5ac"
                alt=""
                className="w-full h-full object-cover object-center overlay overflow-hidden rounded-xl"
              />
            </div>
            <div
              className="overlay left-0 top-0 bottom-0 flex justify-center flex-col pl-48 md:pl-72"
            >
              <h5 className="text-lg font-semibold">Smooting Hairs</h5>
              <span className="">18.309 likes</span>
            </div>
            <a href="details.html" className="stretched-link">
            
            </a>
          </div>
          <div
            className="relative col-span-9 row-span-1 md:col-span-2 md:row-span-2 card"
          >
            <div className="card-shadow rounded-xl">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/layer.jpg?alt=media&token=839c46cc-7182-4c50-8359-62cc5b2fe64b"
                alt=""
                className="w-full h-full object-cover object-center overlay overflow-hidden rounded-xl"
              />
            </div>
            <div
              className="overlay right-0 left-0 top-0 bottom-0 md:bottom-auto flex justify-center md:items-center flex-col pl-48 md:pl-0 pt-0 md:pt-12"
            >
              <h5 className="text-lg font-semibold">Layer Hair cuts</h5>
              <span className="">77.392 likes</span>
            </div>
            <a href="details.html" className="stretched-link">
            
            </a>
          </div>
          <div
            className="relative col-span-9 row-span-1 md:col-span-3 md:row-span-2 card"
          >
            <div className="card-shadow rounded-xl">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/color.png?alt=media&token=547e3eaf-a10e-4153-87ff-4389b0e39c0c"
                alt=""
                className="w-full h-full object-cover object-center overlay overflow-hidden rounded-xl"
              />
            </div>
            <div
              className="overlay right-0 left-0 top-0 bottom-0 md:bottom-auto flex justify-center md:items-center flex-col pl-48 md:pl-0 pt-0 md:pt-12"
            >
              <h5 className="text-lg font-semibold">Color Hair</h5>
              <span className="">22.094 likes</span>
            </div>
            <a href="details.html" className="stretched-link">
      
            </a>
          </div>
          <div className="relative col-span-9 row-span-1 md:col-span-4 card">
            <div className="card-shadow rounded-xl">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/pixie.jpg?alt=media&token=ed1a417d-4297-4bf5-bbd9-e99d61886323"
                alt=""
                className="w-full h-full object-cover object-center overlay overflow-hidden rounded-xl"
              />
            </div>
            <div
              className="overlay left-0 top-0 bottom-0 flex justify-center flex-col pl-48 md:pl-72"
            >
              <h5 className="text-lg font-semibold">Pixie Hair Cuts</h5>
              <span className="">837 Likes</span>
            </div>
            <a href="details.html" className="stretched-link">
         
            </a>
          </div>
        </div>
      </div>
    </section>

    )
}

export default Browse;